// Seven rooms for Le Salon.
// Keys must match backend VALID_SECTIONS in server.py.
// Order is strict — the /rooms landing page renders them in a 3 · 3 · 1 layout.

export const SECTIONS = [
  // Row 1
  {
    slug: "art-de-vivre",
    label: "L'Art de Vivre",
    overline: "Essays · Slow living · Philosophy",
    description: "The why of living beautifully. Essays, confessions, letters to no one in particular.",
    image: "https://images.unsplash.com/photo-1554118811-1e0d58224f24?w=900&q=80",
    accent: "#5C4B3A",
  },
  {
    slug: "cuisine",
    label: "La Cuisine",
    overline: "Food · Patisserie · Recipes",
    description: "Mornings at the boulangerie, evenings at the stove. Recipes, photographs, and small kitchen essays.",
    image: "https://images.unsplash.com/photo-1555507036-ab1f4038808a?w=900&q=80",
    accent: "#A0522D",
  },
  {
    slug: "maison-jardin",
    label: "Maison & Jardin",
    overline: "Interiors · Garden · Design",
    description: "The slow art of the well-arranged home and the garden that surrounds it. Brocante finds, vintage textiles, wisteria in bloom, kitchen herbs by the door.",
    image: "https://images.unsplash.com/photo-1556228453-efd6c1ff04f6?w=900&q=80",
    accent: "#6B7F5C",
  },
  // Row 2
  {
    slug: "style-beaute",
    label: "Le Style & Beauté",
    overline: "Fashion · Beauty · Style",
    description: "Editorials, vintage couture, the perfect trench. How French women dress — and take care of themselves — without trying.",
    image: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=900&q=80",
    accent: "#722F37",
  },
  {
    slug: "voyages",
    label: "Les Voyages",
    overline: "Travel · Escapes · Countryside",
    description: "Paris by morning, Provence by August. Quiet, unrushed travel writing and photography.",
    image: "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=900&q=80",
    accent: "#4A5C75",
  },
  {
    slug: "tresors",
    label: "Les Trésors",
    overline: "Vintage · Heirlooms · Antiques",
    description: "Brocante finds, family heirlooms, antique china, monogrammed linen. The pieces that carry a story from another century into your morning.",
    image: "https://images.unsplash.com/photo-1578500494198-246f612d3b3d?w=900&q=80",
    accent: "#8B3A3A",
  },
  // Row 3 (centered)
  {
    slug: "joie-de-vivre",
    label: "La Joie de Vivre",
    overline: "Moments · Gratitude · Everyday beauty",
    description: "The small, unglamorous joys — a well-poured coffee, a letter that arrived, a morning that felt like a gift. This is where we keep them.",
    image: "https://images.unsplash.com/photo-1519681393784-d120267933ba?w=900&q=80",
    accent: "#6B5B4E",
  },
];

export const SECTION_MAP = Object.fromEntries(SECTIONS.map((s) => [s.slug, s]));

export const getSection = (slug) => SECTION_MAP[slug] || null;

// Migration map: legacy slug -> new slug. Used both for URL redirects (Section.jsx)
// and for defensive frontend fallbacks. The backend performs the DB-side migration
// on startup so posts persist correctly.
export const LEGACY_SLUG_MAP = {
  maison: "maison-jardin",
  jardin: "maison-jardin",
  mode: "style-beaute",
  table: "tresors",
};

export const resolveSlug = (slug) => LEGACY_SLUG_MAP[slug] || slug;
